module.exports = __webpack_public_path__ + "static/media/Imp-Selected.6fb1afa7.png";